import React, { JSX, useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  Outlet,
} from "react-router-dom";
import { Provider, useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState, store } from "./redux/store";
import { CurrencyProvider, useCurrency, CsmPrice, CsmSwitcher, Elements } from "@cosmoola/react-cosmoola-js";

import { fetchAllUsers, listenForAuthChanges } from "./redux/authSlice";

/* Pages */
import MetaCommerce from "./UNIVERSAL/DASHBOARD/MetaCommerce";
import Profile from "./PROFILE/Profile";
import EditProfile from "./PROFILE/EditProfile";
import ProfileSettings from "./PROFILE/ProfileSettings";
import SettingsPrivacy from "./PROFILE/SettingsPrivacy";
import AccountSettings from "./PROFILE/AccountSettings";
import LoginSecurity from "./PROFILE/LoginSecurity";
import ShippingAddress from "./PROFILE/ShippingAddress";
import NotificationMessage from "./CLIENTDASHBOARD/MESSAGES/NotificationMessage";
import ThreadsChat from "./CLIENTDASHBOARD/MESSAGES/ThreadsChat";
import ThreadsPreview from "./CLIENTDASHBOARD/MESSAGES/ThreadsPreview";
import AuthSwitch from "./AUTH/AuthSwitch";
import MetaCommerceDashboard from "./UNIVERSAL/DASHBOARD/MetaCommerceDashboard";
import MetaCommerceCheckout from "./UNIVERSAL/DASHBOARD/MetaCommerceCheckout";
import MetaCommerceCheckoutSuccess from "./UNIVERSAL/DASHBOARD/MetaCommerceCheckoutSuccess";
import MetaClientDashboard from "./CLIENTDASHBOARD/ORDERS/MetaClientDashboard";
import MetaProductReview from "./CLIENTDASHBOARD/ORDERS/MetaProductReview";
import MetaCommerceDetails from "./UNIVERSAL/DASHBOARD/MetaCommerceDetails";
import PaymentMethodDashboard from "./UNIVERSAL/PAY/PaymentMethodDashboard";
import PaymentMethods from "./UNIVERSAL/PAY/PaymentMethods";
import PayoutAgreement from "./UNIVERSAL/PAY/PayoutAgreement";
import PayoutsMethods from "./UNIVERSAL/PAY/PayoutsMethods";
import WireTransferOnboarding from "./UNIVERSAL/PAY/WireTransferOnboarding";
import CommerceManagementDashboard from "./UNIVERSAL/MANAGEMENT/MANAGEMENTDASHBOARD/DASHBOARD/CommerceManagementDashboard";
import HomeLive from "./UNIVERSAL/HomeLive";
import CustomerSupport from "./CLIENTDASHBOARD/CHAT/CustomerSupport";
import Messages from "./CLIENTDASHBOARD/CHAT/Messages";
import MessagesPreview from "./CLIENTDASHBOARD/CHAT/MessagesPreview";
import ResetPassword from "./AUTH/ResetPassword";

import GeneralCommercePartnersReview from "UNIVERSAL/MANAGEMENT/MANAGEMENTDASHBOARD/GENERALCOMMERCE/GeneralCommercePartnersReview";
import MetaCheckout from "UNIVERSAL/DASHBOARD/MetaCheckout";
import Notifications from "CLIENTDASHBOARD/MESSAGES/Notifications";
import Phones from "UNIVERSAL/DASHBOARD/PRODUCTSCATEGORIES/Phones";
import Televisions from "UNIVERSAL/DASHBOARD/PRODUCTSCATEGORIES/Televisions";
import Laptops from "UNIVERSAL/DASHBOARD/PRODUCTSCATEGORIES/Laptops";
import Computers from "UNIVERSAL/DASHBOARD/PRODUCTSCATEGORIES/Computers";
import HomeAppliances from "UNIVERSAL/DASHBOARD/PRODUCTSCATEGORIES/HomeAppliances";
import Tablets from "UNIVERSAL/DASHBOARD/PRODUCTSCATEGORIES/Tablets";
import Security from "UNIVERSAL/DASHBOARD/PRODUCTSCATEGORIES/Security";
import Cameras from "UNIVERSAL/DASHBOARD/PRODUCTSCATEGORIES/Cameras";
import Gaming from "UNIVERSAL/DASHBOARD/PRODUCTSCATEGORIES/Gaming";
import KitchenElectronics from "UNIVERSAL/DASHBOARD/PRODUCTSCATEGORIES/KitchenElectronics";
import Networking from "UNIVERSAL/DASHBOARD/PRODUCTSCATEGORIES/Networking";
import SmartHome from "UNIVERSAL/DASHBOARD/PRODUCTSCATEGORIES/SmartHome";
import Film from "UNIVERSAL/DASHBOARD/PRODUCTSCATEGORIES/Film";
import AudioElectronics from "UNIVERSAL/DASHBOARD/PRODUCTSCATEGORIES/Audio";
import Wearables from "UNIVERSAL/DASHBOARD/PRODUCTSCATEGORIES/Wearables";
import Accessories from "UNIVERSAL/DASHBOARD/PRODUCTSCATEGORIES/Accessories";
import CarElectronics from "UNIVERSAL/DASHBOARD/PRODUCTSCATEGORIES/CarElectronics";
import GPS from "UNIVERSAL/DASHBOARD/PRODUCTSCATEGORIES/GPS";
import HomeEntertainment from "UNIVERSAL/DASHBOARD/PRODUCTSCATEGORIES/HomeEntertainment";
import OfficeElectronics from "UNIVERSAL/DASHBOARD/PRODUCTSCATEGORIES/OfficeElectronics";
import Tools from "UNIVERSAL/DASHBOARD/PRODUCTSCATEGORIES/Tools";
import EbookReaders from "UNIVERSAL/DASHBOARD/PRODUCTSCATEGORIES/EbookReaders";
import MetaStoreHome from "UNIVERSAL/DASHBOARD/MetaStoreHome";
import MetaStores from "UNIVERSAL/DASHBOARD/MetaStores";
import Ahome from "GLOBAL/Ahome";
import ProductsHome from "MARKETPLACE/DASHBOARD/ProductsHome";
import Products from "MARKETPLACE/DASHBOARD/Products";
import AddProducts from "MARKETPLACE/DASHBOARD/AddProducts";
import SellerDashboard from "MARKETPLACE/DASHBOARD/SellerDashboard";
import HostProductOrders from "MARKETPLACE/DASHBOARD/HostProductOrders";
import ClientDashboard from "MARKETPLACE/CLIENTDASHBOARD/ClientDashboard";
import CommerceOnboarding from "MARKETPLACE/DASHBOARD/CommerceOnboarding";
import ProductDetails from "MARKETPLACE/DASHBOARD/ProductDetails";
import ProductCheckout from "MARKETPLACE/DASHBOARD/ProductCheckout";
import ElectronicsAcquisition from "UNIVERSAL/MANAGEMENT/MANAGEMENTDASHBOARD/ACQUISITION/Acquisition";
import ClaimElectronics from "UNIVERSAL/MANAGEMENT/MANAGEMENTDASHBOARD/ACQUISITION/Claim";
import EditPages from "UNIVERSAL/MANAGEMENT/MANAGEMENTDASHBOARD/EDITORIAL/EDIT/PAGES/EditPages";
import EPageContent from "UNIVERSAL/MANAGEMENT/MANAGEMENTDASHBOARD/EDITORIAL/EDIT/PAGES/EPageContent";
import EArticle from "UNIVERSAL/MANAGEMENT/MANAGEMENTDASHBOARD/EDITORIAL/EDIT/POSTS/EArticle";
import EditPost from "UNIVERSAL/MANAGEMENT/MANAGEMENTDASHBOARD/EDITORIAL/EDIT/POSTS/EditPosts";
import MoreNews from "UNIVERSAL/MANAGEMENT/MANAGEMENTDASHBOARD/EDITORIAL/EDIT/POSTS/MoreNews";
import News from "UNIVERSAL/MANAGEMENT/MANAGEMENTDASHBOARD/EDITORIAL/EDIT/POSTS/News";
import Claim from "UNIVERSAL/MANAGEMENT/MANAGEMENTDASHBOARD/ACQUISITION/Claim";



  
const MainLayout = ({ children }: { children: React.ReactNode }) => {
  return <div className="pb-16">{children}</div>;
};


const AppRoutes = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { user, authLoaded } = useSelector((state: RootState) => state.auth);

  
  useEffect(() => {
    const handleContextMenu = (e: MouseEvent) => {
      e.preventDefault();
    };

    document.addEventListener('contextmenu', handleContextMenu);

    return () => {
      document.removeEventListener('contextmenu', handleContextMenu);
    };
  }, []);

  useEffect(() => {
    dispatch(listenForAuthChanges());
  }, [dispatch]);

  
{/*
    useEffect(() => {
  if (user) {
    // 1 hour = 60 minutes × 60 seconds × 1000 ms = 3,600,000 ms
    dispatch(startInactivityWatcher({ timeoutMs: 60 * 60 * 1000 }));
  }
}, [dispatch, user]);
  
  
  */}


{/*
    useEffect(() => {
  if (user) {
    dispatch(startInactivityWatcher({ timeoutMs: 5 * 60 * 1000 })); // 5 min
  }
}, [dispatch, user]);
  
  */}


  useEffect(() => {
    dispatch(fetchAllUsers());
    
 
  }, [dispatch]);
  


  if (!authLoaded) {
    return <div style={{ textAlign: "center", marginTop: 100 }}></div>;
  }



  const ProtectedSupportRoute = () => {
    const authUser = useSelector((state: RootState) => state.auth.user);
  
    if (!authUser) return <Navigate to="/AuthSwitch" replace />;
  
    const hasAccess = authUser.role?.includes("support") || authUser.role?.includes("admin");
  
    if (!hasAccess) return <Navigate to="/" replace />;
  
    return <Outlet />;
  };

  return (
    <>

    <Routes>
      {/* ✅ Publicly accessible pages/tabs */}
      <Route
  path="/"
  element={
    <>
    
  
        {/*


    
  <GeneralHomes/>  

    <HomeLive />     

      <WhatsNew /> 
        <Route index element={<Ahome />} />
    
       */}
    </>
  }
/>


   

        <Route path="/" element={<Outlet  />}>

<Route index element={<RootRedirect />} />
      <Route path="/AuthSwitch" element={<AuthSwitch />} />
         <Route path="/News" element={<News />} />






 


{/* ================= PROTECTED ROUTES ================= */}

          <Route path="/profile/:userId" element={<Profile />} />
          <Route path="/profile" element={<Profile />} />
          
  
          <Route path="/EditProfile/:userId" element={<EditProfile />} />
          <Route path="/ProfileSettings/:userId" element={<ProfileSettings />} />
        
  <Route path="/loginsecurity/:userId" element={<LoginSecurity />} />
  <Route path="/PaymentMethodDashboard/:userId" element={<PaymentMethodDashboard />} />
  <Route path="/shippingaddress/:userId" element={<ShippingAddress />} />
<Route path="/notifications/:userId" element={<Notifications/>} />
<Route path="/notificationmessage/:messageId" element={<NotificationMessage />} />




<Route path="/notificationmessage/:messageId" element={<NotificationMessage />} />

<Route path="/Phones" element={<Phones />} />
<Route path="/Televisions" element={<Televisions />} />
<Route path="/Tablets" element={<Tablets />} />
<Route path="/Security" element={<Security />} />
<Route path="/HomeAppliances" element={<HomeAppliances />} />
<Route path="/Computers" element={<Computers />} />
<Route path="/Laptops" element={<Laptops />} />
<Route path="/SmartHome" element={<SmartHome />} />
<Route path="/Networking" element={<Networking />} />
<Route path="/KitchenElectronics" element={<KitchenElectronics />} />
<Route path="/Gaming" element={<Gaming />} />
<Route path="/Film" element={<Film />} />
<Route path="/Audio" element={<AudioElectronics />} />
<Route path="/Cameras" element={<Cameras />} />
<Route path="/Wearables" element={<Wearables />} />
<Route path="/Tools" element={<Tools />} />
<Route path="/HomeEntertainment" element={<HomeEntertainment />} />
<Route path="/OfficeElectronics" element={<OfficeElectronics />} />
<Route path="/CarElectronics" element={<CarElectronics />} />
<Route path="/Accessories" element={<Accessories />} />
<Route path="/GPS" element={<GPS />} />
<Route path="/EbookReaders" element={<EbookReaders />} />

<Route path="/CommerceOnboarding/:userId" element={<CommerceOnboarding />} />
<Route path="/manager/:userId" element={<CommerceManagementDashboard />} />
<Route path="/GeneralCommercePartnersReview/:brandId" element={<GeneralCommercePartnersReview />} />
<Route path="/MetaCommerce" element={<MetaCommerce />} />
<Route path="/MetaCommerceDetails/:listingId" element={<MetaCommerceDetails />} />
<Route path="/MetaCommerceDashboard/:userId" element={<MetaCommerceDashboard />} />
<Route path="/MetaCommerceCheckout/:userId" element={<MetaCommerceCheckout />} />
<Route path="/MetaCommerceCheckoutSuccess/:userId" element={<MetaCommerceCheckoutSuccess />} />
<Route path="/MetaCheckout/:userId" element={<MetaCheckout />} />
<Route path="/MetaClientDashboard/:userId" element={<MetaClientDashboard />} />
<Route path="/MetaProductReview/:guestId/:listingId/:orderId" element={<MetaProductReview />} />
<Route path="/MetaStores" element={<MetaStores />} />
<Route path="/MetaStoreHome/:brandId" element={<MetaStoreHome />} />

<Route path="/ClientDashboard/:userId" element={<ClientDashboard />} />
<Route path="/SellerDashboard/:userId" element={<SellerDashboard />} />
<Route path="/ProductHome" element={<ProductsHome />} />
<Route path="/Products" element={<Products />} />
<Route path="/AddProducts" element={<AddProducts />} />
<Route path="/AddProducts/:listingId" element={<AddProducts />} />
<Route path="/HostProductOrders/:userId" element={<HostProductOrders />} />
<Route path="/ProductDetails/:listingId" element={<ProductDetails />} />
<Route path="/ProductCheckout/:userId" element={<ProductCheckout />} />




  



{/*===============================================*/}

  <Route path="/CommerceManagementDashboard/:userId" element={<CommerceManagementDashboard />} />


<Route path="/acquisition" element={<ElectronicsAcquisition />} />
<Route path="/claim" element={<Claim />} /> 


  <Route path="/PayoutAgreement/:userId" element={<PayoutAgreement />} />
  <Route path="/PaymentMethodDashboard/:userId" element={<PaymentMethodDashboard />} />
  <Route path="/payoutsmethods/:userId" element={<PayoutsMethods />} />
  <Route path="/WireTransferOnboarding/:userId" element={<WireTransferOnboarding />} />
  <Route path="/PaymentMethods/:userId" element={<PaymentMethods />} />

{/* ================= FALLBACK ================= 
<Route path="*" element={<Navigate to={user ? "/" : "/AuthSwitch"} replace />} />
*/}
<Route path="*" element={<Navigate to="/ProductHome" replace />} />

      </Route>

    
    </Routes>
</>


  );};


{/*} REPLACE WITH:
const RootRedirect: React.FC = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setShow(true), 2000);
    return () => clearTimeout(timer);
  }, []);

  if (show) return <ProductsHome />;
  return <Home />;
};

const RootRedirect: React.FC = () => {
  const { user } = useSelector((s: RootState) => s.auth);
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!user) return;
    const timer = setTimeout(() => setShow(true), 3000);
    return () => clearTimeout(timer);
  }, [user]);

  if (show) return <ProductsHome />;
  return <Home />;
};


*/}

const RootRedirect: React.FC = () => {
  const { user } = useSelector((s: RootState) => s.auth);
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!user) return;
    const timer = setTimeout(() => setShow(true), 3000);
    return () => clearTimeout(timer);
  }, [user]);

  if (show) return <ProductsHome />;
  return <Ahome />;
};



const App = () => (
  <Provider store={store}>
         <CurrencyProvider 
  apiKey={process.env.REACT_APP_COSMOOLA_PUBLISHABLE_KEY!}
>


    <Router>
      <AppRoutes />
    </Router>
    </CurrencyProvider>

  </Provider>

);

export default App;
